module.exports = __webpack_public_path__ + "img/premier.3f4fb02d.png";